import React from 'react';
import { siteDisplayName, siteHue, tenantDisplayName } from '../utils/sites';
import { useTenants } from '../contexts/TenantContext';

interface SitePillProps {
  tenantId?: string | null;
  siteId?: string | null;
  showTenant?: boolean;
  className?: string;
}

export const SitePill: React.FC<SitePillProps> = ({
  tenantId,
  siteId,
  showTenant = false,
  className = '',
}) => {
  const { tenants } = useTenants();
  const hue = siteHue(siteId);
  const siteName = siteDisplayName(tenants, tenantId, siteId);
  const tenantName = tenantDisplayName(tenants, tenantId);

  return (
    <span className={`inline-flex items-center gap-1.5 min-w-0 ${className}`}>
      {showTenant && (
        <span className="text-xs text-gray-500 truncate">{tenantName}</span>
      )}
      <span
        className="inline-flex items-center gap-1.5 text-xs font-medium px-2 py-0.5 rounded-full border whitespace-nowrap"
        style={{
          backgroundColor: `hsl(${hue} 70% 94%)`,
          color: `hsl(${hue} 50% 28%)`,
          borderColor: `hsl(${hue} 45% 80%)`,
        }}
      >
        <span
          className="w-1.5 h-1.5 rounded-full flex-shrink-0"
          style={{ backgroundColor: `hsl(${hue} 55% 45%)` }}
        />
        {siteName}
      </span>
    </span>
  );
};
